import { useState } from 'react';
import { useDispatch } from 'react-redux';

import useRequest from '@swf/core/hooks/useRequest';
import type { Dispatch } from '@swf/core/store';
import type { PokerContext } from '@swf/core/types/Poker';
import type {
  CancelClubTableRequest,
  CancelClubTableResponse,
  HGCancelCashGameReply,
  HgClubInfo
} from '@swf/generated/types/api/v0/SwHomeGames';
import { handleServerResponse } from '@swf/poker';

export interface RequestBody {
  body: CancelClubTableRequest;
  fetchService: PokerContext['fetchService'];
}

const useDeleteCashGame = (clubs: HgClubInfo[]) => {
  const request = useRequest();
  const { modal } = useDispatch<Dispatch>();
  const [loading, setLoading] = useState(false);

  const handleDeleteCashGame = ({ body, fetchService }: RequestBody) => {
    setLoading(true);
    request({ service: 'homeGames.cancelClubTableRequest', body }).subscribe({
      next: ({ body }: { body: CancelClubTableResponse }) => {
        const { error } = handleServerResponse<CancelClubTableResponse, HGCancelCashGameReply>({
          response: body,
          accessor: 'hgCancelCashGameReply'
        });
        setLoading(false);
        modal.close();

        if (error) {
          modal.enqueue({
            path: '/notifications/simple-notification',
            locationState: { msg: error }
          });
        } else {
          fetchService('clubInfo', {
            gameFilter: {
              gameCategoryMask: 255,
              clubIds: clubs.map(({ clubId }: HgClubInfo) => clubId)
            }
          });
        }
      }
    });
  };

  return { handleDeleteCashGame, loading };
};

export default useDeleteCashGame;
